import type { Event } from '@patsnap/tahiti-core';
import type { PatentProfileWithMatchedTechFeature, RetrievalResult, TechFeatureSynonym } from '../types';
import type { RETRIEVAL_STRATEGY } from '../constants';

/**
 * 检索耗时
 */
export interface RetrievalTimeCost {
    /**
     * 检索耗时，单位：秒
     */
    timeSpend: number;
    /**
     * 节省(人工)检索时间，单位：秒
     */
    timeSaved: number;
}

/**
 * 复杂检索服务
 */
export interface FtoReportComplexRetrievalService {
    /**
     * 获取检索结果
     * @returns 检索结果
     */
    search(): Promise<RetrievalResult>;
    /**
     * 终止检索
     */
    terminate(): Promise<void>;
    /**
     * 检索开始事件
     * @description 检索开始事件
     */
    onRetrievalStart: Event<void>;
    /**
     * 检索结束事件
     * @description 所有检索结束事件
     */
    onRetrievalComplete: Event<void>;
    /**
     * 专利有匹配特征时的事件
     */
    onPatentFeatureMatched: Event<PatentProfileWithMatchedTechFeature[]>;
    /**
     * 技术特征同义词接收事件
     */
    onTechFeatureSynonym: Event<TechFeatureSynonym[]>;
    /**
     * 检索耗时反馈
     * @param time 检索耗时，单位：秒
     */
    onRetrievalTime: Event<RetrievalTimeCost>;
}

export const FtoReportComplexRetrievalService = Symbol.for('FtoReportComplexRetrievalService');

export interface ComplexRetrievalCallbacks {
    onRetrievalRunning: (name: RETRIEVAL_STRATEGY, running: boolean) => void;
    onRetrievalSuccess: (name: RETRIEVAL_STRATEGY, result: RetrievalResult) => void;
    onPatentFeatureMatched: (patentProfiles: PatentProfileWithMatchedTechFeature[]) => void;
    onTechFeatureSynonym: (synonyms: TechFeatureSynonym[]) => void;
    /**
     * 检索耗时反馈
     * @param time 检索耗时，单位：秒
     */
    onRetrievalTime: (time: RetrievalTimeCost) => void;
}


export interface FtoReportComplexRetrievalRepository {
    search(taskId: string, callbacks: ComplexRetrievalCallbacks): Promise<void>;
    /**
     * 终止当前的检索（循环）
     */
    terminate(): Promise<void>;
}

export const FtoReportComplexRetrievalRepository = Symbol.for('FtoReportComplexRetrievalRepository');
